export default "__VITE_ASSET__cYOr3fE9__"